var lg_6711R1P070B_DVD = {
    name: "6711R1P070B_DVD",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,170,186,250,226],
        },
        {
            function: "KEY_OPEN",
            name: "KEY_OPEN",
            icon: "KEY_OPEN",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,174,235,90,226],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,187,213,106,226],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,171,235,170,226],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,183,213,170,226],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,175,214,170,226],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,191,170,170,226],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,170,171,127,98],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,181,86,191,98],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,173,86,223,98],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,186,173,95,98],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,171,86,239,98],
        },
        {
            function: "KEY_CLEAR",
            name: "KEY_CLEAR",
            icon: "KEY_CLEAR",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,174,173,175,98],
        },
        {
            function: "SCAN-BACK",
            name: "SCAN-BACK",
            icon: "SCAN-BACK",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,173,117,186,226],
        },
        {
            function: "SCAN-FORWARD",
            name: "SCAN-FORWARD",
            icon: "SCAN-FORWARD",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,186,234,186,226],
        },
        {
            function: "SKIP-BACK",
            name: "SKIP-BACK",
            icon: "SKIP-BACK",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,182,234,218,226],
        },
        {
            function: "SKIP-FORWARD",
            name: "SKIP-FORWARD",
            icon: "SKIP-FORWARD",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,171,117,218,226],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,170,245,234,226],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,181,117,122,226],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,181,234,234,226],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,187,90,183,98],
        },
        {
            function: "KEY_TITLE",
            name: "KEY_TITLE",
            icon: "KEY_TITLE",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,173,173,183,98],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,189,90,175,98],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,181,218,235,98],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,173,219,107,98],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,170,214,247,98],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,182,173,111,98],
        },
        {
            function: "DISPLAY",
            name: "DISPLAY",
            icon: "DISPLAY",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,173,235,106,226],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,190,181,87,98],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,170,182,251,98],
        },
        {
            function: "KEY_ANGLE",
            name: "KEY_ANGLE",
            icon: "KEY_ANGLE",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,171,173,215,98],
        },
        {
            function: "KEY_SETUP",
            name: "KEY_SETUP",
            icon: "KEY_SETUP",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,174,219,91,98],
        },
        {
            function: "MARKER",
            name: "MARKER",
            icon: "MARKER",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,181,93,125,98],
        },
        {
            function: "KEY_SEARCH",
            name: "KEY_SEARCH",
            icon: "KEY_SEARCH",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,173,93,189,98],
        },
        {
            function: "PROGRAM",
            name: "PROGRAM",
            icon: "PROGRAM",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,189,181,91,98],
        },
        {
            function: "KEY_ZOOM",
            name: "KEY_ZOOM",
            icon: "KEY_ZOOM",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,171,93,221,98],
        },
        {
            function: "KEY_AGAIN",
            name: "KEY_AGAIN",
            icon: "KEY_AGAIN",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,186,218,187,98],
        },
        {
            function: "A-B",
            name: "A-B",
            icon: "A-B",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,182,218,219,98],
        },
        {
            function: "RANDOM",
            name: "RANDOM",
            icon: "RANDOM",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,181,109,123,98],
        },
        {
            function: "KEY_NUMERIC_STAR",
            name: "KEY_NUMERIC_STAR",
            icon: "KEY_NUMERIC_STAR",
            command: [68,0,4,190,2,255,5,190,2,161,1,47,18,243,16,209,2,164,173,55,107,118,175,182,171,98],
        },
    ]
}
export default lg_6711R1P070B_DVD